<div *ngIf="busy">
  Please wait...
</div>

<div *ngIf="!busy">
  
  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Filter: <input type="text" #filter />

  <form [formGroup]="form">
    <table class="table">
      <tr *ngFor="let f of form.controls | bynamerank: filter.value"> <!-- p of players | byname: filter.value -->
        <ng-container [formGroup]="f">
          <td>
            {{f.value.player.getFullName()}}
            <br />
            <span style="font-size: 9pt">{{f.value.id}}</span>
          </td>
          <td><a href="#" (click)="showHistory($event, f.value.id)">Pop up History</a></td>
          <td>
            <select formControlName="rank">
              <option value="">N/R</option>
              <option value="A">A</option>
              <option value="B">B</option>
              <option value="C">C</option>
              <option value="D">D</option>
              <option value="E">E</option>
              <option value="F">F</option>
            </select>
          </td>
        </ng-container>
      </tr>
    </table>
  </form>


</div>